// extracted by mini-css-extract-plugin
export default {"container":"_3MA5s","header":"_3Ns0o","headerText":"_25VY3"};